export default __webpack_public_path__ + "static/media/taiPOS.33748bf1.svg";